import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  BaseCard,
  BaseCardBody,
  BaseCardHeader,
  Button,
  CheckBoxField,
} from '@unite-us/app-components';

function ScreeningNeedSelector({
  initiallyChecked,
  isHighRisk,
  needs,
  onSubmit,
  isSupersetEnabled,
}) {
  const [needChecks, setNeedChecks] = useState(needs.map((need = {}) => ({
    id: need.service_type && need.service_type.id,
    name: need.service_type && need.service_type.name,
    value: initiallyChecked,
  })));

  const onChange = (id) => () => {
    const index = needChecks.findIndex((needCheck) => needCheck.id === id);
    setNeedChecks([
      ...needChecks.slice(0, index),
      { ...needChecks[index], value: !needChecks[index].value },
      ...needChecks.slice(index + 1),
    ]);
  };

  const handleSubmit = () => {
    const checkedNeeds = needChecks.filter(({ value }) => Boolean(value));
    const originalCheckedNeeds = needs.filter((need) => checkedNeeds.some(({ id }) => need.service_type.id === id));
    onSubmit(originalCheckedNeeds);
  };

  return (
    <BaseCard className="screening-need-selector">
      <BaseCardHeader
        title={
          isSupersetEnabled ? 'Suggested Service Types' : 'Suggested Referrals'
        }
        className="text-lg"
      />
      <BaseCardBody className="screening-need-selector__body p-2">
        {!isSupersetEnabled && (
          <p>
            This client has been determined{' '}
            {isHighRisk && (
              <span data-testid="high-risk-fragment">
                to be <strong>high risk</strong> and{' '}
              </span>
            )}
            to have the following needs. Selected service types will be added to
            a referral:
          </p>
        )}
        {isSupersetEnabled && (
          <p>
            The results of this screening suggest that this client{' '}
            {isHighRisk && (
              <span data-testid="high-risk-fragment">
                is <strong>high risk</strong> and{' '}
              </span>
            )}
            might need support with the following service types. Select the ones
            you want to use to find relevant resources.
          </p>
        )}
        <div style={{ marginTop: '1rem' }} />
        <form>
          {needChecks.map(({ name, id, value }) => (
            <CheckBoxField
              key={id}
              id={id}
              label={name}
              onChange={onChange(id)}
              value={value}
            />
          ))}
          <div style={{ marginTop: '1rem' }} />
          <Button
            disabled={needChecks.filter(({ value }) => Boolean(value)).length === 0}
            fullWidth
            id="screening-need-selector-submit-button"
            label={isSupersetEnabled ? 'Find Resources' : 'Create Referrals'}
            onClick={handleSubmit}
            primary
          />
        </form>
      </BaseCardBody>
    </BaseCard>
  );
}

ScreeningNeedSelector.propTypes = {
  initiallyChecked: PropTypes.bool,
  needs: PropTypes.array,
  onSubmit: PropTypes.func,
  isHighRisk: PropTypes.bool,
  isSupersetEnabled: PropTypes.bool,
};

ScreeningNeedSelector.defaultProps = {
  initiallyChecked: false,
  needs: [],
  onSubmit: () => {},
  isHighRisk: false,
  isSupersetEnabled: false,
};

export default ScreeningNeedSelector;
